import "./Method.module.css";
import Header from "@/reusable_sections/Header";
import CooperationProcess from "./sections/CooperationProcess";
import DrivenByExcellence from "./sections/DrivenByExcellence";
import FaqSection from "./sections/FaqSection";
import Footer from "@/reusable_sections/Footer";
export default function MethodPage() {
  return <div>
      <Header />
      <CooperationProcess />
      <DrivenByExcellence />
      <FaqSection />
      <Footer />
    </div>;
}